import React from "react";
import { Stream } from "@cloudflare/stream-react";

const CloudflareVideoPlayer = () => {
  return (
    <div>
      <Stream controls src="04fda67e9da87003495f0c5c62ad822e" />
    </div>
  );
};

export default CloudflareVideoPlayer;
